import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../nest-api";

@Injectable()
export class PollingV2Provider {

  private _service: string = 'polling';
  private _model: string = 'pollingV2';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getPollingDetail(params: any): Observable<any> {

    const _method: string = 'POST';
    const _func: string = 'getPollingDetailV2';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public addPolling(params: any): Observable<any> {

    const _method: string = 'POST';
    const _func: string = 'addPollingV2';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public updatePollingSFGO(params: any): Observable<any> {

    const _method: string = 'POST';
    const _func: string = 'updatePollingV2';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public votePollingSFGO(params: any): Observable<any> {

    const _method: string = 'POST';
    const _func: string = 'votePollingV2';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/polling/polling-v2.ts